







import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings } from "../core/services/configService";
import LegalPageLayout from "../components/legal/LegalPageLayout.vue";

@Component({
  components: { LegalPageLayout },
})
export default class WayverPage extends Vue {
  wayverAndRelease: string = "";

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    let url = `${Settings.HostName}/api/czconfigs/legal-settings`;
    let data = await new CrudService().httpGet(url);
    if (data == null || data.data == null || !data.ok) {
      console.error("Crash getting cz legal settings");
      return;
    }

    this.wayverAndRelease = data.data.wayver;
  }
}
